export const validatePassword = (
  password: string,
  t?: (key: string) => string
): string | null => {
  if (!password) return null;

  const errorMessage = t
    ? t("register.validation.passwordMinLength")
    : "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character";

  // Check minimum length
  if (password.length < 8) {
    return errorMessage;
  }

  // Check for uppercase letter
  if (!/[A-Z]/.test(password)) {
    return errorMessage;
  }

  // Check for lowercase letter
  if (!/[a-z]/.test(password)) {
    return errorMessage;
  }

  // Check for number
  if (!/\d/.test(password)) {
    return errorMessage;
  }

  // Check for special character - all required special characters: !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~
  if (!/[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(password)) {
    return errorMessage;
  }

  return null;
};
